var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.162,
    cy: 8,
    r: 8,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A66C2",
    fillRule: "evenodd",
    d: "M.162 1.2a1.2 1.2 0 0 1 1.2-1.2h13.6a1.2 1.2 0 0 1 1.2 1.2v13.6a1.2 1.2 0 0 1-1.2 1.2h-13.6a1.2 1.2 0 0 1-1.2-1.2V1.2Zm4.944 12.194V6.169H2.704v7.225h2.402ZM3.905 5.182c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016Zm4.93 8.212h-2.4s.03-6.547 0-7.225h2.4v1.023l-.015.025h.016v-.025c.319-.493.89-1.193 2.164-1.193 1.58 0 2.765 1.033 2.765 3.252v4.143h-2.402V9.529c0-.972-.347-1.634-1.216-1.634-.664 0-1.059.447-1.232.878-.064.154-.08.37-.08.586v4.035Z",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedin;